import { render, staticRenderFns } from "./OrderPhotoGalleryAlbumReplacement.vue?vue&type=template&id=6153b2d4&"
import script from "./OrderPhotoGalleryAlbumReplacement.vue?vue&type=script&lang=js&"
export * from "./OrderPhotoGalleryAlbumReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports